var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJobLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.187,
    height: 48.249,
    viewBox: "0 0 36.187 48.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-map-marker-alt",
    "data-name": "Icon awesome-map-marker-alt",
    d: "M16.234,47.275C2.542,27.426,0,25.388,0,18.093a18.093,18.093,0,0,1,36.187,0c0,7.3-2.542,9.332-16.234,29.182a2.263,2.263,0,0,1-3.719,0Zm1.859-21.643a7.539,7.539,0,1,0-7.539-7.539A7.539,7.539,0,0,0,18.093,25.632Z",
    fill: "#e61f2a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJobLocation);
export default __webpack_public_path__ + "static/media/icon-job-location.6715621b.svg";
export { ForwardRef as ReactComponent };